import React, { Component } from "react";
import "./register.css"
import Logo from "../../asset/images/Logo1.png"
import { Link } from "react-router-dom";
import Image from "../../asset/images/image1.jpeg"

class PasswordReset extends Component {
    render() {
        return (
            <div className="registration_container">



                <section className="registration image">
                    <div className="style"></div>
                    <div className="style"></div>
                    <img src={Image} alt="register_image" />
                </section>



                <section className="registration content">

                    <header className="register_header">
                        <Link to="/"><img src={Logo} alt="logo" /></Link>
                    </header>


                    <div className="register_body">
                        <h2>Password Reset</h2>
                        <p>Create a new password to securely access your account</p>
                        <form>
                            <input placeholder="Password" required />
                            <input placeholder="Confirm Paswword" required />
                            <button> Submit </button>

                        </form>
                        <p>New to GeoGIS? <Link to="/signup"><span className="blue">Join Us</span></Link></p>

                    </div>


                    <footer className="register_footer">

                    </footer>



                </section>
                
            </div>
        )
    }
}



export default PasswordReset